import { render, staticRenderFns } from "./videoBack.vue?vue&type=template&id=9d595780&scoped=true"
import script from "./videoBack.vue?vue&type=script&lang=js"
export * from "./videoBack.vue?vue&type=script&lang=js"
import style0 from "./videoBack.vue?vue&type=style&index=0&id=9d595780&prod&lang=scss"
import style1 from "./videoBack.vue?vue&type=style&index=1&id=9d595780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_85bb6ef93cf5a779f9b064f420832c70/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d595780",
  null
  
)

export default component.exports